const USDT_APPROVE_LOADING = 'USDT_APPROVE_LOADING';
const USDT_APPROVE_SUCCESS = 'USDT_APPROVE_SUCCESS';
const USDT_APPROVE_FAILURE = 'USDT_APPROVE_FAILURE';

export const usdtApproveActions = {
  USDT_APPROVE_LOADING,
  USDT_APPROVE_SUCCESS,
  USDT_APPROVE_FAILURE,
};
